import { useEffect, useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import PlansetsClientChart from "./PlansetsClientChart";
import PlansetsJobTypeChart from "./PlansetJobTypeChart";
import api from "../../../../common/api";
import LeadsWonConversionChart from "./LeadsWonConversionChart";

const PlansetClientJobTypeChart = () => {
  const [topClients, setTopClients] = useState({});
  const [jobTypeChart, setJobTypeChart] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get("/planset/top-planset-clients");
        const data = res.data || {};
        setTopClients(data.top_clients || {});
        setJobTypeChart(data.job_type_chart || {});
      } catch (err) {
        setError(err.message || "Failed to load data.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <Row className="g-3">
      <Col lg={4}>
        <Card className="chart-inner-card">
          <PlansetsClientChart topClients={topClients} loading={loading} error={error}/>
        </Card>
      </Col>
      <Col lg={4}>
        <Card className="chart-inner-card">
          <PlansetsJobTypeChart jobTypeChart={jobTypeChart} loading={loading} error={error}/>
        </Card>
      </Col>
      <Col lg={4}>
        <Card className="chart-inner-card">
          <LeadsWonConversionChart jobTypeChart={jobTypeChart} loading={loading} error={error}/>
        </Card>
      </Col>
    </Row>
  );
};
export default PlansetClientJobTypeChart;